<template>
  <div class="list">
    <p>{{fields[name].name}}</p>
    <input :class="{error: fields[name].errorId}" type="text" v-model="fields[name].value" @blur="isEmpty" @focus="$emit('focus')" @keydown="removeError">
    <div class="invalid_text" v-if="name === 'url' || !fields[name].isNullable">{{fields[name].errors[fields[name].errorId]}}</div>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex'

  const {mapMutations, mapState} = createNamespacedHelpers('mainPage')

  export default {
    props: ['name'],
    computed: {
      ...mapState([
        'fields',
        'currentTabId'
      ]),
    },
    methods: {
      ...mapMutations([
        'setField'
      ]),
      isEmpty() {
        if (!this.fields[this.name].value && !this.fields[this.name].isNullable) {
          this.setField({fieldId: this.name, fieldPropertyId: 'errorId', value: 'empty'})
        }
      },
      removeError() {
        if (!this.fields[this.name].value) {
          this.setField({fieldId: this.name, fieldPropertyId: 'errorId', value: null})
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

  .filled {
    & ~ label {
      top: -2px !important;
      opacity: 1 !important;
      visibility: visible !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/create-form/Input.vue